import React from "react";
import { Home, School, Users, GraduationCap, ShoppingCart } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "../../lib/utils";
import { useViewMode } from "../../client/contexts/ViewModeContext";
import { routes } from "wasp/client/router";

export default function BottomNav() {
  const location = useLocation();
  const { viewMode, setViewMode } = useViewMode();

  const navItems = [
    {
      label: "Home",
      icon: Home,
      path: "/dashboard",
      onClick: () => setViewMode("home"),
      isActive: viewMode === "home" && location.pathname === "/dashboard",
    },
    {
      label: "Campus Life",
      icon: School,
      path: "/dashboard",
      onClick: () => setViewMode("campus"),
      isActive: viewMode === "campus" && location.pathname === "/dashboard",
    },
    {
      label: "Student",
      icon: Users,
      path: "/dashboard",
      onClick: () => setViewMode("student_life"),
      isActive: viewMode === "student_life" && location.pathname === "/dashboard",
    },
    {
      label: "Academics",
      icon: GraduationCap,
      path: "/dashboard",
      onClick: () => setViewMode("academics"),
      isActive: viewMode === "academics" && location.pathname === "/dashboard",
    },
    {
      label: "Marketplace",
      icon: ShoppingCart,
      path: "/dashboard",
      onClick: () => setViewMode("marketplace"),
      isActive: viewMode === "marketplace" && location.pathname === "/dashboard",
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-header-bg border-t border-header-border lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = item.isActive !== undefined 
            ? item.isActive 
            : location.pathname === item.path;
            
          return (
            <Link
              key={item.label}
              to={item.path}
              onClick={item.onClick}
              className={cn(
                "flex flex-col items-center justify-center w-full h-full gap-1 transition-colors",
                isActive ? "text-primary" : "text-header-text-muted hover:text-header-text"
              )}
            >
              <item.icon className={cn("w-5 h-5", isActive && "animate-in zoom-in-75 duration-300")} />
              <span className="text-[10px] font-medium truncate px-1">
                {item.label}
              </span>
              {isActive && (
                <span className="absolute bottom-1 w-1 h-1 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
